export const MIN_VALID_AGE = 18;
export const MAX_VALID_AGE = 110;
export const VULNERABLY_AGE = 90;
export const SECTION_TYPE = {
    PERSONAL_DATA: 'PersonalData',
    PRECONTRACTUAL_DOCS: 'PrecontractualDocs',
    EMAIL_OTP_VALIDATION: 'EmailOTPValidation',
    ACCESS_DATA: 'AccessData',
};
